import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { getReturnReportItems, getReturnReportSummaries } from './apis'
import { GetReturnReportItemsReq, GetReturnReportSummariesReq, ReturnReportItem, ReturnReportSummary } from './types'

/**
 * 쿼리 키 앞머리에 라우트 메뉴코드(rgr20 — placeholder)를 둔다.
 * `MenuOnSessionWrap.remove()` 가 탭을 닫을 때 키에 이 코드가 든 캐시를 함께 지운다(gr02 준용).
 */
const PATH = ['return', 'returnInquiry', 'rgr20'] as const

export const returnInquiryQueryKeys = {
  all: PATH,
  /** `seq` — 같은 조건으로 [조회]를 다시 눌러도 새로 가져오게 조회 회차를 키에 싣는다. */
  summaries: (params: GetReturnReportSummariesReq | null, seq: number) => [...PATH, 'HEAD', params, seq] as const,
  items: (params: GetReturnReportItemsReq | null) => [...PATH, 'ITEM', params] as const,
  shippers: (scope: string) => [...PATH, 'SHIPPERS', scope] as const,
}

/** HEAD 조회. 조건이 null 이면(진입 직후·초기화 뒤) 부르지 않는다. 실패 알림은 화면(useRgr02Screen)이 띄운다 — 전역 알림은 끈다(LOGISPRD-14909). */
export const useGetReturnReportSummaries = (params: GetReturnReportSummariesReq | null, seq: number): UseQueryResult<ReturnReportSummary[], Error> =>
  useQuery({
    queryKey: returnInquiryQueryKeys.summaries(params, seq),
    queryFn: async () => (await getReturnReportSummaries(params as GetReturnReportSummariesReq)).data?.items ?? [],
    enabled: params !== null,
    meta: { noErrorMessage: true },
  })

/** ITEM 조회. HEAD 행을 고르기 전(null)에는 부르지 않는다. */
export const useGetReturnReportItems = (params: GetReturnReportItemsReq | null): UseQueryResult<ReturnReportItem[], Error> =>
  useQuery({
    queryKey: returnInquiryQueryKeys.items(params),
    queryFn: async () => (await getReturnReportItems(params as GetReturnReportItemsReq)).data?.items ?? [],
    enabled: params !== null,
  })
